import { useNavigate } from "react-router-dom";
import useAuth from "../../../hook/useAuth";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";


export const AddVehicleModel = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const [name, setName] = useState<string>("");
    const [makes, setMakes] = useState<any[]>([]);
    const [makeId, setMakeId] = useState<number>(0);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        axios.get(`${baseURL}makes`)
            .then((response) => {
                setMakes(response?.data?.map((item: any) => {
                    return { value: item.makeID, label: item.name }
                }))
                setMakeId(response?.data[0]?.makeID || 0)
            }).catch(error => {
                setMakeId(0);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}models?userId=${auth?.id}`,
                JSON.stringify({
                    name,
                    makeID: makeId
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>

            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Model</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={name}
                                                placeholder="Name"
                                                onChange={(e) => setName(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Make</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={makeId}
                                                onChange={(e) => setMakeId(Number(e.target.value))}
                                                required
                                            >
                                                {makes?.map((make: any) => (
                                                    <option key={make.value} value={make.value}>
                                                        {make.label}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}